import React from "react";
import multiWorkspaces from "icons/multiWorkspaces.svg";
import pen from "icons/pen-icon.svg";
import trash from "icons/trash.svg";
import Checkbox, {
  checkboxStates,
} from "@visiblethread/react-components/dist/components/Checkbox";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { systemAdminRemoveMemberModal } from "components/Modal/confModalTypes";

const WorkspacesUsersTableItem = ({
  member,
  multipleWorkspaces,
  firstName,
  lastName,
  licensed,
  dictionary,
  readabilitySettings,
  acronymSettings,
  discoverySettings,
  excelOutputs,
  userAdmin,
  workspaceName,
  workspaceId,
}) => {
  const dispatch = useDispatch();

  const handleRemoveMember = () => {
    dispatch(
      showModal(
        modalTypes.CONFIRMATION,
        systemAdminRemoveMemberModal(
          member,
          workspaceName,
          workspaceId,
          dispatch
        )
      )
    );
  };

  return (
    <div
      className="system_admin__container__item__table__row"
      data-testid="workspaces-users-table-item"
    >
      <span title={member}>{member}</span>
      {multipleWorkspaces ? (
        <span>
          <img
            className="system_admin__container__item__table__row__multi_workspaces__image"
            src={multiWorkspaces}
            alt="multiWorkspaces"
          />
        </span>
      ) : (
        <span>&nbsp;</span>
      )}
      <span title={firstName}>{firstName}</span>
      <span title={lastName}>{lastName}</span>
      <span>
        <Button
          onClick={() => {
            dispatch(
              showModal(modalTypes.EDIT_PERMISSIONS, {
                workspaceId,
                username: member,
                licensed,
                dictionary,
                readabilitySettings,
                acronymSettings,
                discoverySettings,
                excelOutputs,
                userAdmin,
              })
            );
          }}
          variant={buttonVariants.borderless}
          dataTestId="editMemberButton"
          content={<img src={pen} alt="pen" />}
        />
      </span>
      <span>
        <Checkbox
          state={licensed ? checkboxStates.checked : checkboxStates.empty}
          disabled
          id="cblicense"
          value="license_checkbox"
          handleChange={() => {}}
        />
      </span>
      <span>
        <Checkbox
          state={dictionary ? checkboxStates.checked : checkboxStates.empty}
          disabled
          id="cbdictionary"
          value="dictionary_checkbox"
          handleChange={() => {}}
        />
      </span>
      <span>
        <Checkbox
          state={
            readabilitySettings ? checkboxStates.checked : checkboxStates.empty
          }
          disabled
          id="cbreadabilitysettings"
          value="readability_settings_checkbox"
          handleChange={() => {}}
        />
      </span>
      <span>
        <Checkbox
          state={
            acronymSettings ? checkboxStates.checked : checkboxStates.empty
          }
          disabled
          id="cbacronymsettings"
          value="acronym_settings_checkbox"
          handleChange={() => {}}
        />
      </span>
      <span>
        <Checkbox
          state={
            discoverySettings ? checkboxStates.checked : checkboxStates.empty
          }
          disabled
          id="cbdiscoverysettings"
          value="discovery_settings_checkbox"
          handleChange={() => {}}
        />
      </span>
      <span>
        <Checkbox
          state={excelOutputs ? checkboxStates.checked : checkboxStates.empty}
          disabled
          id="cbexceloutputs"
          value="excel_outputs_checkbox"
          handleChange={() => {}}
        />
      </span>
      <span>
        <Checkbox
          state={userAdmin ? checkboxStates.checked : checkboxStates.empty}
          disabled
          id="cbuseradmin"
          value="user_admin_checkbox"
          handleChange={() => {}}
        />
      </span>
      <span className="system_admin__container__item__table__row__actions">
        <Button
          onClick={handleRemoveMember}
          variant={buttonVariants.borderless}
          dataTestId="removeMemberButton"
          content={<img src={trash} alt="pen" />}
        />
      </span>
    </div>
  );
};

export default WorkspacesUsersTableItem;

WorkspacesUsersTableItem.propTypes = {
  member: PropTypes.string.isRequired,
  multipleWorkspaces: PropTypes.bool.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  licensed: PropTypes.bool.isRequired,
  dictionary: PropTypes.bool.isRequired,
  readabilitySettings: PropTypes.bool.isRequired,
  acronymSettings: PropTypes.bool.isRequired,
  discoverySettings: PropTypes.bool.isRequired,
  excelOutputs: PropTypes.bool.isRequired,
  userAdmin: PropTypes.bool.isRequired,
  workspaceName: PropTypes.string.isRequired,
  workspaceId: PropTypes.number.isRequired,
};
